module.exports = __webpack_public_path__ + "static/media/idoHoko.2111b4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/adl/idoHoko.png
// module id = 1696
// module chunks = 1